import React from 'react';
import { icons, colors } from '../../shared/constants'
import './_subscription-cta.scss';  // Ensure your CSS file is correctly referenced
import Button from '../../UI/Button/Button';
import { useTheme } from '../../contextes/ThemeContext';
import { Context } from '../../contextes/ModalContext';

interface SubscriptionCtaProps {
    onOpen: () => void;
}

const SubscriptionCta: React.FC<SubscriptionCtaProps> = ({ onOpen }) => {
    const darkTheme = useTheme();
    const modalContext = React.useContext(Context);

    const handleOpen = () => {
        modalContext?.openModal('Subscription');
        onOpen();
    }

    return (
        <div className="subscription-card-wrapper">
            <div className={darkTheme ? "subscription-card dark" : "subscription-card"}>
                <div className="badge">NEW!</div>
                <img src={icons.SUBSCRIPTION_STAR_ICON} alt="Star Icon" className="star-icon-cta" />
                <p>Support this publication and get unlimited access to all <a href='/' >membership content</a> for a periodical fee!</p>
                <Button
                    className={{dark: 'subscription-cta-navy-button', light:'subscription-cta-navy-button'}}
                    styleType={{dark: 'navy-dark', light: 'navy'}}
                    type='button'
                    style={ { width: '100%' } }
                    onClick={() => handleOpen()}
                >
                    Support now!
                </Button>
            </div>
        </div >
    );
};

export default SubscriptionCta;
